import { NgModule } from '@angular/core';
import { TranslatedNamePipeModule } from 'src/app/pipes/translated-name/translated-name-pipe.module';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';

import { WeightedItemModal } from './weighted-item.modal';
import { IonicModule } from '@ionic/angular';
import { DebounceClickDirectiveModule } from 'src/app/directives/debounce-click/debounce-click-directive.module';
import { FormsModule } from '@angular/forms';
import { NumericKeyboardComponentModule } from 'src/app/components/shared/numeric-keyboard/numeric-keyboard-component.module';

@NgModule({
  declarations: [WeightedItemModal],
  imports: [
    CommonModule,
    TranslatedNamePipeModule,
    IonicModule,
    TranslocoModule,
    DebounceClickDirectiveModule,
    FormsModule,
    NumericKeyboardComponentModule
  ],
  exports: [WeightedItemModal]
})
export class WeightedItemModalModule {}
